import { render } from "./AccommodationIndex.vue?vue&type=template&id=27601ef0"
import script from "./AccommodationIndex.vue?vue&type=script&lang=js"
export * from "./AccommodationIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__